import Vue from 'vue';
import Vuetify from 'vuetify';
// Vuetify styles are imported via global.scss to ensure correct cascade order
import '@fortawesome/fontawesome-free/css/all.css'

// 1. Import jQuery & Custom Setup FIRST.
// Checks global window properties and sets up $.event.special.
// Using a separate file ensures the import body runs before subsequent imports.
import './jquery-setup'; 

// 2. Now import jQuery UI. It will find window.jQuery available.
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.min.css';

// 3. Import other jQuery plugins
import 'jquery-datetimepicker'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import '@/assets/css/reset.css'
import '@/assets/css/buttons.css'
import '@/assets/css/global.css'
// global.scss is now imported in main.js to ensure proper Vite processing
import "../modules/inb/css/Inb.css"
import '@/assets/css/tables.css'
import '@/assets/css/tabs.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

import de from '@/i18n/de'

Vue.use(Vuetify);


export default new Vuetify({
    lang: {
        locales: { de },
        current: 'de'
    },
    icons: {
        iconfont: 'fa',
    },
    global: {
        ripple: false
    },
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary  : '#0a68b8',
                secondary: '#808080',
                accent   : '#8c9eff',
                error    : '#b71c1c',
                project  : '#0a68b8',
                warning  : '#ffeb3b',
                fatal    : '#000000',
            },
        },
    },
});
